import { handleActions } from "redux-actions";
import {
    SHIPPING_PROMOTION_COMPLETE,
    SHIPPING_PROMOTION_DELETE,
    SHIPPING_PROMOTION_DELETE_COMPLETE,
    SHIPPING_PROMOTION_REQUEST,
    SHIPPING_PROMOTIONS_COMPLETE,
    SHIPPING_PROMOTIONS_REQUEST,
    SHIPPING_PROMOTIONS_RESET,
} from "constants/action-types";
import { PAGE_SIZE } from "constants/shipping-promotions";
interface IState {
    error?: boolean;
    errorObject: any;
    isFetching: boolean;
    isDeleting: boolean;
    nextPage: string | null;
    hasMoreToFetch: boolean;
    results: string[];
}

const initialState: IState = {
    error: undefined,
    errorObject: null,
    isFetching: false,
    isDeleting: false,
    nextPage: null,
    hasMoreToFetch: true,
    results: [],
};

export const shippingPromotions = handleActions(
    {
        [SHIPPING_PROMOTIONS_REQUEST]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [SHIPPING_PROMOTION_REQUEST]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [SHIPPING_PROMOTION_DELETE]: (state: IState): IState => {
            return {
                ...state,
                isDeleting: true,
            };
        },
        [SHIPPING_PROMOTION_COMPLETE]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    errorObject: payload,
                    isFetching: false,
                };
            }

            return {
                ...state,
                error,
                errorObject: null,
                isFetching: false,
                results: payload,
            };
        },
        [SHIPPING_PROMOTION_DELETE_COMPLETE]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    errorObject: payload,
                    isDeleting: false,
                };
            }

            return {
                ...state,
                error,
                errorObject: null,
                isDeleting: false,
                results: state.results.filter((id) => id !== payload),
            };
        },
        [SHIPPING_PROMOTIONS_COMPLETE]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    errorObject: payload,
                    isFetching: false,
                };
            }
            const ids = payload.ids;
            return {
                ...state,
                error,
                errorObject: null,
                isFetching: false,
                results: state.results.length ? (state.results.concat(ids) as string[]) : ids,
                hasMoreToFetch: ids.length >= PAGE_SIZE ? true : false,
                nextPage: payload.nextPage,
            };
        },
        [SHIPPING_PROMOTIONS_RESET]: (): IState => {
            return initialState;
        },
    },
    initialState
);
